import React, { useContext } from "react";
import "./Valeurs.scss";
import { MobileContext } from "../../context/MobileContext";

const Valeurs = () => {
  const { isMobile, isTablet } = useContext(MobileContext);
  return (
    <div className="valeurs-container">
      <div className="valeurs-image-section">
        <img
          loading="lazy"
          src="/img/photo4.jpg"
          alt="Maison luxiueuse avec une piscine"
          data-aos="fade-right"
          data-aos-duration="1000"
          data-aos-offset="200"
        />
      </div>
      <div className="valeurs-text-section">
        <h2 data-aos="fade-down" data-aos-duration="1000" data-aos-offset="200">
          Des valeurs fortes
        </h2>
        <p data-aos="fade-left" data-aos-duration="1000" data-aos-offset="200">
          En confiant votre projet à <b>SBHM Concept</b>, vous êtes assurés de
          la qualité et du savoir-faire de notre réseau de professionnels. Doté
          de <b>12 ans</b> d'expérience, notre savoir-faire n’a de cesse de
          maintenir les valeurs et la qualité qui font sa réputation auprès de
          ses clients.
        </p>

        {!isMobile && !isTablet && <br />}
        {!isMobile && !isTablet && <br />}

        <p data-aos="fade-left" data-aos-duration="1000">
          Notre réseau de professionnels qualifiés se met à votre disposition
          pour réaliser votre projet de construction de piscine en vous
          apportant un service de qualité et de proximité.
        </p>
      </div>
    </div>
  );
};

export default Valeurs;
